export default __webpack_public_path__ + "static/media/cliente6.ba0d3ea4.jpg";